import { FC } from "react";
import {
	ItemAndModsContainer,
	NoModificationsSelected,
	QuoteCustomizationsSummaryContainer,
	SpecialModificationNotes
} from "pages/CustomQuote/AddQuotePage/addQuotePage.styles.ts";
import { CustomQuoteLineItemGrid } from "components/CustomQuote/CustomQuoteDetail/CustomQuoteDetail.styles.ts";
import { Modification } from "components/Common/LineItemGrid";
import {
	AddSpecialModificationHeader,
	CQModificationsHeaderText
} from "components/NewOrders/AddModification/constants.ts";
import { SpecialModificationNotesText } from "constants/text.ts";
import { models } from "types/api/viewModels.ts";

interface QuoteCustomizationsSummaryProps {
	revision: models["CustomQuoteRevisionViewModel"] | undefined;
}

const QuoteCustomizationsSummary: FC<QuoteCustomizationsSummaryProps> = ({ revision }) => {
	const { notes, cqLineItem, specialMods } = revision ?? {};
	const { cqMods, sku } = cqLineItem ?? {};

	return (
		<QuoteCustomizationsSummaryContainer>
			<ItemAndModsContainer>
				<h4>{CQModificationsHeaderText}</h4>
				{sku && <div data-testid="cq-code-display">{sku ?? ""}</div>}
				{cqMods?.length ? (
					<CustomQuoteLineItemGrid
						mainRowContent={[]}
						modificationRows={cqMods.map((modification, index) => (
							<Modification
								description={modification.description}
								key={`${modification.id ?? modification.sku ?? "cq-mod"}-${index}`}
								lineNumber={undefined}
								showLineNumber={false}
								title={modification.sku}
								values={[
									{
										value: modification.value ?? undefined,
										description: modification.description
									}
								]}
							/>
						))}
					/>
				) : (
					<NoModificationsSelected>None Selected</NoModificationsSelected>
				)}
			</ItemAndModsContainer>
			<ItemAndModsContainer>
				<h4>{AddSpecialModificationHeader}</h4>
				{specialMods?.length ? (
					<CustomQuoteLineItemGrid
						isListPrice={true}
						mainRowContent={[]}
						isSpecialModification={true}
						modificationRows={specialMods.map((modification, index) => (
							<Modification
								description={modification.description}
								key={`${modification.id ?? modification.sku ?? "special-mod"}-${index}`}
								lineNumber={undefined}
								title={modification.sku}
								specialModification={modification}
								showSpecialModPrice={false}
							/>
						))}
					/>
				) : (
					<NoModificationsSelected>None Selected</NoModificationsSelected>
				)}
			</ItemAndModsContainer>
			{notes?.trim() !== "" && (
				<SpecialModificationNotes>
					{SpecialModificationNotesText}
					<div>{notes}</div>
				</SpecialModificationNotes>
			)}
		</QuoteCustomizationsSummaryContainer>
	);
};

export default QuoteCustomizationsSummary;
